
import { mapActions, mapGetters } from 'vuex'
import { jsFn } from '@/utils/js-fn'
import DeleteAccountConfirm from './delete-account-confirm'

export default {
    name: 'delAccount',
    components: { DeleteAccountConfirm },
    data() {
        const validatePass = (rule, value, callback) => {
            if(jsFn.isEmpty(value)) {
                callback(new Error(this.$t('error_1')))
            } else {
                callback()
            }
        }
        return {
            delModel: false,
            dataForm: {
                passwd: ''
            },
            dataRule: {
                passwd: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'coreApi/getUserInfo'
        })
    },
    methods: {
        ...mapActions(['logOut']),
        handleSubmit(name) {
            if (!this.userInfo.is_set_pw) {
                this.delModel = true
                return
            }
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.delModel = true
                }
            })
        },
        iWantDel() {
            this.delModel = false
            this.$Spin.show() // 開啟加載畫面
            // 未設密碼時不可帶 old_pw，否則後端回 400
            let pw = this.userInfo.is_set_pw ? this.dataForm.passwd : undefined
            this.$store.dispatch('coreApi/deleteAccount', pw).then(res => {
                 this.logOut()
            }).catch((e) => {
                this.$Message.warning({
                    // error 1 = UserNotFound（密碼錯誤）；其他為一般失敗
                    content: this.$t(e && e.error === 1 ? 'error_37' : 'auth_13'),
                    duration: 5,
                    closable: true
                })
            }).finally(() => {
                this.$Spin.hide()
            })
        },
        backToUserinfo() {
            this.$router.push({ name: 'userinfo' })
        }
    },
    created() {
    }
}
